export default function SmartColour(colour) {
  let response = {
    background: "white",
    text: "black",
    headline: "black",
  };

  if (colour) {
    if (colour.text === "default") {
      if (
        colour.background === "white" ||
        colour.background === "blue" ||
        colour.background === "none"
      ) {
        // Declare which colours should have black text
        response.text = "black";
      } else {
        // Default to white text
        response.text = "white";
      }
    } else {
      response.text = colour.text;
    }

    if (colour.headline === "default") {
      // Default to whatever the text colour is
      response.headline = response.text;
    } else {
      response.headline = colour.headline;
    }

    // Set the background colour
    response.background = colour.background;
  }
  return response;
}
